import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationCircle,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import ProductCard from "../products/ProductCard";
import emptyCart from "../../assets/emptyCart.png";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase";
import axios from "axios";
import OrderSuccess from "../orders/OrderSuccess";
import LoadingSpinner from "../utilities/LoadingSpinner";
import { ToastContainer, toast } from "react-toastify";
import "../../styles/ReactToastify.css";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";

export default function Cart({
  cartItemsCount,
  user,
  cartItems,
  setCartItems,
  coupons,
  userInfo,
  setCheckOut,
  products,
  orderSuccess,
  setOrderSuccess,
  handleCartUpdate,
  reachedMax,
  setReachedMax,
  updateInventory,
  setUpdateInventory,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const { promiseInProgress } = usePromiseTracker();
  const [userData, setUserData] = useState(userInfo);
  const [cartItemDetails, setCartItemDetails] = useState([]);
  const [expectedDelivery, setExpectedDelivery] = useState("");
  const [checkOutError, setCheckOutError] = useState("");
  const [youMayLike, setYouMayLike] = useState();
  const [dimensions, setDimensions] = useState({
    lengthProperty: 0,
    breadth: 0,
    height: 0,
    weight: 0,
  });

  // Protects the cart page from disappearing on refresh.
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  // Protects the state on refresh.
  useEffect(() => {
    setUserData(userInfo);
    // console.log(userInfo);
  }, [userInfo]);

  useEffect(() => {
    if (cartItems?.length > 0) {
      // console.log("products", products);
      let fetchedDimensions = {
        lengthProperty: "",
        breadth: "",
        height: "",
        weight: "",
      };
      const fetchedDetails = cartItems?.map((cartItem) => {
        const item = products.filter(
          (product) => product._id === cartItem.productId
        );

        const transformedItem = {
          ...item[0],

          selectedSize: cartItem.selectedSize,
          quantity: cartItem.quantity,
        };

        fetchedDimensions = {
          lengthProperty: Math.max(
            fetchedDimensions.lengthProperty,
            transformedItem.length
          ),
          breadth: Math.max(fetchedDimensions.breadth, transformedItem.breadth),
          height: Math.max(fetchedDimensions.height, transformedItem.height),
          weight:
            Number(fetchedDimensions.weight) +
            Number(transformedItem.weight) * cartItem.quantity,
        };

        return transformedItem;
      });

      // console.log("fetchedDimensions", fetchedDimensions);
      setDimensions(fetchedDimensions);
      // console.log("fetchedCartItems", fetchedDetails);
      setCartItemDetails(fetchedDetails);
    }
  }, [cartItems, products]);

  const [priceSummary, setPriceSummary] = useState({
    total: cartItemDetails?.reduce((acc, item) => acc + item.price, 0),
    totalMrp: cartItemDetails?.reduce((acc, item) => acc + item.mrp, 0),
    couponDiscount: 0,
    shippingCharges: 0,
  });

  const [couponInput, setCouponInput] = useState("");
  const [couponMessage, setCouponMessage] = useState("");

  // Updates Price summary according to items in cart.
  const handlePriceSummaryUpdate = () => {
    // console.log("Updating Price", cartItemDetails);

    const total = cartItemDetails?.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );
    const totalmrp = cartItemDetails?.reduce(
      (acc, item) => acc + item.mrp * item.quantity,
      0
    );

    let shipmentCharges = 0;
    if (total <= 300) {
      shipmentCharges = 59;
    } else if (total > 300 && total <= 1000) {
      shipmentCharges = 84;
    } else if (total > 1000 && total <= 1499) {
      shipmentCharges = 119;
    } else {
      shipmentCharges = 0;
    }

    setPriceSummary({
      total: total,
      totalMrp: totalmrp,
      couponDiscount: 0,
      shippingCharges: parseFloat(shipmentCharges),
    });
  };

  // Updates quantity/size of the product when user selects from the field btn in cart.
  const handleChange = (productId, value, field, currentSize) => {
    const updatedArray = cartItems?.map((item) => {
      let updatedItem = {};
      if (item.productId === productId && item.selectedSize === currentSize) {
        if (field === "quantity") {
          updatedItem = {
            ...item,
            quantity: parseInt(value),
          };
        } else if (field === "size") {
          updatedItem = {
            ...item,
            selectedSize: value,
            quantity: 1,
          };
        }
        return updatedItem;
      }
      return item;
    });

    // removing duplicate items if have same id and size and increasing quantity
    const updatedCartItems = [];
    const seen = {};
    if (field === "size") {
      updatedArray.forEach((item) => {
        const itemKey = `${item.productId}-${item.selectedSize}`;
        if (!seen[itemKey]) {
          seen[itemKey] = true;
          updatedCartItems.push(item);
        } else if (
          item.productId === productId &&
          item.selectedSize === value
        ) {
          const duplicateItem = updatedArray.find(
            (existingItem) =>
              existingItem.productId === productId &&
              existingItem.selectedSize === value
          );
          duplicateItem.quantity += 1;
        }
      });
    } else {
      updatedArray.forEach((item) => {
        updatedCartItems.push(item);
      });
    }

    if (updatedCartItems.length > 0) {
      console.log("Updating Cart");
      if (user) {
        axios
          .post(`${process.env.REACT_APP_BACKEND_LINK}/updatecart`, {
            userInfo,
            updatedCartItems,
          })
          .then((res) => console.log(res))
          .catch((err) => console.log(err));
      } else {
        // update cart in localstorage
        localStorage.setItem(
          "ambhosCartItems",
          JSON.stringify(updatedCartItems)
        );
      }
      setCartItems(updatedCartItems);
    }
  };

  // Removes the item from the cartItems.
  const handleRemoveCartItem = (productId, selectedSize) => {
    const updatedCartItems = cartItems.filter(
      (item) =>
        !(item.productId === productId && item.selectedSize === selectedSize)
    );
    if (user) {
      axios
        .post(`${process.env.REACT_APP_BACKEND_LINK}/updatecart`, {
          userInfo,
          updatedCartItems,
        })
        .then((res) => console.log(res))
        .catch((err) => console.log(err));
    } else {
      localStorage.setItem("ambhosCartItems", JSON.stringify(updatedCartItems));
    }
    setCartItems(updatedCartItems);
    // console.log(updatedCartItems);
    console.log("Item Removed.");
  };

  // Updates price summary on redirecting to cart page or on updating cartItems.
  useEffect(() => {
    // console.log("Starting");
    if (cartItemDetails.length > 0) {
      // get shipping charges and date of delivery
      // console.log(dimensions);
      if (user) {
        const pincode = userInfo?.shippingAddress?.pincode;
        const fetchShipmentDetails = async () => {
          await axios
            .post(`${process.env.REACT_APP_BACKEND_LINK}/getshippingdetails`, {
              pincode,
              dimensions,
            })
            .then((res) => {
              // console.log(res.data.formattedDate);
              // console.log("Shipment Charges", res.data.shipmentCharges);
              setExpectedDelivery(res.data.formattedDate);
            })
            .catch((err) => console.log(err));
        };
        fetchShipmentDetails();
      }
      handlePriceSummaryUpdate();
      setCouponMessage("");
      setCouponInput("");
      const filteredProducts = products.filter(
        (product) =>
          !cartItemDetails.some((item) => item.productId === product._id)
      );
      setYouMayLike(filteredProducts);
    }
  }, [cartItemDetails]);

  // Updates couponDiscount if coupon is correct.
  const handleCoupon = () => {
    setCouponMessage("");
    let flag = 0;
    const totalAmount = priceSummary.total + priceSummary.shippingCharges;
    if (couponInput === "CHM10") {
      let itemDiscount = 0;
      cartItemDetails?.map((item) => {
        if (item.brandName === "Bowgun") {
          itemDiscount = itemDiscount + item.price * item.quantity * 0.1;
        }
        return;
      });
      setPriceSummary({
        ...priceSummary,
        couponDiscount: itemDiscount,
      });
      setCouponMessage("10% Discount on Bowgun Products Applied!");
      flag = 1;
    } else {
      coupons.map((coupon) => {
        if (coupon.code === couponInput && coupon.minPrice <= totalAmount) {
          setPriceSummary({
            ...priceSummary,
            couponDiscount: coupon.discount,
          });
          setCouponMessage("Coupon Applied!");
          flag = 1;
        }
      });
    }
    if (flag === 0) {
      setPriceSummary({
        ...priceSummary,
        couponDiscount: 0,
      });
      setCouponMessage("Coupon is invalid!");
    }
  };

  // Verifies payment and then creates order in shiprocket as well as stores all info in mongodb
  const handleOrderCreation = (razorpayInfo) => {
    // console.log(razorpayInfo);
    trackPromise(
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_LINK}/paymentverification`,
          razorpayInfo
        )
        .then((res) => {
          if (res.data.success === true) {
            console.log("Proceed to create order");
            trackPromise(
              axios
                .post(`${process.env.REACT_APP_BACKEND_LINK}/createorder`, {
                  userInfo,
                  cartItems,
                  priceSummary,
                  razorpayInfo,
                })
                .then((res) => {
                  // console.log(res);
                  setOrderSuccess({
                    flag: true,
                    data: res.data.data.orderHistory[
                      res.data.data.orderHistory.length - 1
                    ],
                  });
                  setCartItems([]);
                  setUpdateInventory(!updateInventory);
                  const updatedCartItems = [];
                  axios
                    .post(`${process.env.REACT_APP_BACKEND_LINK}/updatecart`, {
                      userInfo,
                      updatedCartItems,
                    })
                    .then((res) => console.log(res))
                    .catch((err) => console.log(err));
                })
                .catch((err) => console.log(err))
            );
          } else {
            console.log("Payment Verification failed");
          }
        })
    );
  };

  const handleCart = async () => {
    if (!user) {
      setCheckOut(false);
      return;
    }

    if (
      userInfo.phoneNumber === null ||
      userInfo?.shippingAddress?.pincode === null
    ) {
      setCheckOutError(
        "Please update Mobile Number and Shipping Address before placing the order."
      );
      return;
    }
    // console.log(cartItems);
    const amount = (
      priceSummary.total +
      priceSummary.shippingCharges -
      priceSummary.couponDiscount
    ).toFixed(2);

    const {
      data: { key },
    } = await axios.get(`${process.env.REACT_APP_BACKEND_LINK}/getkey`);

    axios
      .post(`${process.env.REACT_APP_BACKEND_LINK}/checkout`, {
        amount,
      })
      .then((res) => {
        // console.log(res.data);
        const options = {
          key: key,
          amount: amount,
          currency: "INR",
          name: "Ambhos",
          description: "Order Payment",
          image:
            "https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/ambhos_full_logo.png",
          order_id: res.data.order.id,
          handler: (response) => {
            handleOrderCreation(response);
          },
          prefill: {
            name: userData.firstName + " " + userData.lastName,
            email: userData.email,
            contact: userData.phoneNumber,
          },
          notes: {
            address: "Razorpay Corporate Office",
          },
          theme: {
            color: "#e95911",
          },
        };
        const razor = new window.Razorpay(options);
        razor.open();
      })
      .catch((err) => console.log(err));
  };

  // Shows side toast on adding to cart
  useEffect(() => {
    if (reachedMax !== 0) {
      if (reachedMax === 200) {
        // console.log("Showing toast 200");
        toast.success("Added to Cart!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (reachedMax === 500) {
        // console.log("Showing toast 500");
        toast.error("Already max quantity in cart", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      setReachedMax(0);
    }
  }, [reachedMax]);

  const { total, totalMrp, couponDiscount, shippingCharges } = priceSummary;

  // const handleSwitch = () => {
  //   setOrderSuccess({
  //     flag: true,
  //     data: "64aa602a050084ae12bf09bf",
  //   });
  // };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <>
      {promiseInProgress === true && (
        <div className="absolute flex justify-center pt-60 h-full w-full bg-white bg-opacity-90">
          <LoadingSpinner />
        </div>
      )}
      {orderSuccess.flag === true ? (
        <OrderSuccess
          orderSuccess={orderSuccess}
          setOrderSuccess={setOrderSuccess}
        />
      ) : (
        <div className="md:mx-56">
          {/* <button onClick={handleSwitch}>Chekcout</button> */}
          <h1 className="text-2xl font-semibold mt-10 md:mt-20 mb-2">
            Shopping Cart
          </h1>
          {cartItems?.length === 0 ? (
            <div className="h-72 flex flex-col justify-center items-center">
              <img
                src="https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/emptyCart.png"
                className="w-16"
                alt=""
              />
              <p className="mt-2 text-lg">Your cart is empty!</p>
              <Link to="/store">
                <button className="mt-5 border border-ambhosOrange bg-ambhosOrange text-white rounded-md py-1 px-3">
                  Explore
                </button>
              </Link>
            </div>
          ) : (
            <div className="flex flex-col md:flex-row w-full">
              <div className="md:w-3/4 p-4 pt-7 border-x-2 md:border-x-0 border-t-2 md:border-t-2">
                {user ? (
                  userInfo?.shippingAddress?.pincode !== null ? (
                    <div className="border-b">
                      <p className="">
                        <span className="text-ambhosOrange font-semibold">
                          Deliver to:{" "}
                        </span>
                        {/* 46 BTM Layout, Bangalore, India - 560029 */}
                        {userData?.shippingAddress?.address +
                          ", " +
                          userData?.shippingAddress?.city +
                          ", " +
                          userData?.shippingAddress?.state +
                          ", " +
                          userData?.shippingAddress?.country +
                          " - " +
                          userData?.shippingAddress?.pincode}
                      </p>
                      <p className="font-semibold">
                        <span className="font-semibold">
                          Expected Delivery By{" "}
                        </span>
                        <span className="text-ambhosOrange">
                          {expectedDelivery
                            ? expectedDelivery
                            : "Calculating..."}
                        </span>
                      </p>
                      <div className="text-right my-5 md:mb-5">
                        <Link to="/profile">
                          <button className="border px-2 py-1 rounded-md border-ambhosOrange text-ambhosOrange text-sm active:scale-95">
                            Change Address
                          </button>
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="border-b h-14 flex items-end pb-3">
                      <p>
                        <FontAwesomeIcon icon={faExclamationCircle} />{" "}
                        <Link
                          to="/profile"
                          className="text-ambhosOrange font-semibold cursor-pointer"
                        >
                          Add Address
                        </Link>{" "}
                        to calculate shipping charges and expected Delivery
                        date.
                      </p>
                    </div>
                  )
                ) : (
                  <div className="border-b h-14 flex items-end pb-3">
                    <p>
                      <FontAwesomeIcon icon={faExclamationCircle} />{" "}
                      <Link
                        to="/signin"
                        className="text-ambhosOrange font-semibold cursor-pointer"
                      >
                        Login
                      </Link>{" "}
                      to calculate shipping charges and expected Delivery date.
                    </p>
                  </div>
                )}
                <ul className="md:p-4 pt-4 w-full space-y-5">
                  {cartItemDetails?.map((item) => (
                    <li
                      key={item._id}
                      className="flex items-center justify-between py-2"
                    >
                      <div className="flex">
                        <img
                          src={item.images ? item.images[0] : ""}
                          alt={item.name}
                          className="h-8 w-8 object-contain"
                        />
                        <div className="w-32 md:w-64 lg:w-96 flex flex-col ml-4">
                          <h3 className="font-medium text-sm inline-block">
                            {item.brandName + " " + item.productName} (
                            {item.color})
                          </h3>
                          <p className="text-gray-500 text-xs inline-block">
                            ₹{item.price?.toFixed(2)}
                          </p>
                        </div>
                      </div>

                      <div className="">
                        <select
                          id="size"
                          name="size"
                          className="block w-full p-1 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-ambhosOrange focus:border-ambhosOrange sm:text-sm"
                          value={item.selectedSize}
                          onChange={(e) =>
                            handleChange(
                              item._id,
                              e.target.value,
                              "size",
                              item.selectedSize
                            )
                          }
                        >
                          {item.availableSize?.map((size) => {
                            if (size.inventory > 0) {
                              return (
                                <option value={size.size}>{size.size}</option>
                              );
                            }
                          })}
                        </select>
                      </div>

                      {/* Quantity  */}
                      <div className="">
                        <select
                          id="quantity"
                          name="quantity"
                          className="block w-full p-1 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-ambhosOrange focus:border-ambhosOrange sm:text-sm"
                          value={item.quantity}
                          onChange={(e) =>
                            handleChange(
                              item._id,
                              e.target.value,
                              "quantity",
                              item.selectedSize
                            )
                          }
                        >
                          {item.availableSize?.map(
                            (size) =>
                              size.size === item.selectedSize &&
                              Array.from(
                                { length: size.inventory },
                                (_, index) => index + 1
                              ).map((quantity) => (
                                <option key={quantity} value={quantity}>
                                  {quantity}
                                </option>
                              ))
                          )}
                        </select>
                      </div>
                      <button
                        onClick={() =>
                          handleRemoveCartItem(item._id, item.selectedSize)
                        }
                        className="text-red-500 font-medium"
                      >
                        <FontAwesomeIcon icon={faTrashCan} />
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Side Container */}
              <div className="md:p-10 pt-10 pl-5 border-2">
                <div>
                  <h2 className="text-sm font-semibold">OFFERS & COUPONS</h2>
                  <ul className="w-64 md:w-80 list-[square] mt-2 pl-5 marker:text-xs text-[16px] text-black space-y-1">
                    {coupons.map((coupon) => (
                      <li key={coupon.code}>
                        Use Coupon{" "}
                        <span className="font-semibold">{coupon.code}</span> for
                        ₹{coupon.discount} off on orders above ₹
                        {coupon.minPrice}
                      </li>
                    ))}
                  </ul>
                  <div className="w-[305px] md:w-full border-2 mt-5 p-2 rounded-md flex justify-between">
                    <input
                      type="text"
                      placeholder="Enter Coupon"
                      value={couponInput}
                      onChange={(e) => setCouponInput(e.target.value)}
                      className="outline-none"
                    />
                    <button
                      className="text-ambhosOrange active:scale-95"
                      onClick={handleCoupon}
                    >
                      Apply
                    </button>
                  </div>
                  {couponMessage && (
                    <small className="font-semibold text-ambhosOrange">
                      {couponMessage}
                    </small>
                  )}
                </div>

                <div>
                  <h2 className="mt-5 text-sm font-semibold">
                    PRICE SUMMARY ({cartItemsCount} Items)
                  </h2>
                  <ul className="text-sm mt-3 mr-5 md:mr-0 space-y-1">
                    <li className="flex justify-between">
                      <p>Total MRP</p>
                      <p>₹ {totalMrp?.toFixed(2)}</p>
                    </li>
                    <li className="flex justify-between">
                      <p>Discount on MRP</p>
                      <p>- ₹ {(totalMrp - total).toFixed(2)}</p>
                    </li>
                    <li className="flex justify-between">
                      <p>Coupon Discount</p>
                      <p>- ₹ {couponDiscount.toFixed(2)}</p>
                    </li>
                    <li className="flex justify-between">
                      <p>Shipping Charges</p>
                      <p>₹ {shippingCharges.toFixed(2)}</p>
                    </li>
                    {total < 1499 ? (
                      <li className="text-xs pt-3 text-ambhosOrange">
                        <p>
                          Add more products of worth ₹{1499 - total} to avail
                          free shipping.
                        </p>
                      </li>
                    ) : (
                      <li className="text-xs pt-3 text-ambhosOrange">
                        <p>Yay! Your order is eligible for free shipping.</p>
                      </li>
                    )}
                  </ul>
                  <hr className="my-2" />
                  <div className="flex justify-between font-semibold mr-5 md:mr-0 mb-5">
                    <p>Payable Amount</p>
                    <p>
                      ₹ {(total + shippingCharges - couponDiscount).toFixed(2)}
                    </p>
                  </div>
                </div>

                <div className="flex justify-center align-middle">
                  {/* If isAuth then divert to razorpay else login page */}
                  <button
                    className="block w-80 md:w-full -ml-3 md:-ml-0 my-5 md:my-0 rounded-md py-2 bg-ambhosOrange text-white font-medium"
                    onClick={handleCart}
                  >
                    Checkout
                  </button>
                </div>
                {checkOutError && (
                  // <div className="">
                  <div className="flex justify-center align-middle ">
                    <p className="text-sm text-center text-ambhosOrange bg-red-200 -ml-3 md:-ml-0 w-72 my-2 md:mt-3 p-2 font-semibold">
                      {checkOutError}{" "}
                      <Link className="underline cursor-pointer" to="/profile">
                        Update here
                      </Link>
                    </p>
                  </div>
                  // </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <section className="mt-16">
        <h1 className="text-2xl md:text-3xl font-semibold">
          You May Also Like
        </h1>
        <div className="mt-5 flex space-x-5 overflow-scroll scrollbar-hide">
          {youMayLike?.map((product) => (
            <div key={product._id} className="">
              <ProductCard
                id={product._id}
                image={product?.images[0]}
                title={product.productName}
                brand={product.brandName}
                color={product.color}
                sizes={product.availableSize ? product.availableSize : []}
                rating={product.rating ? product.rating : ""}
                price={product.price}
                mrp={product.mrp}
                handleCartUpdate={handleCartUpdate}
              />
            </div>
          ))}
        </div>
      </section>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}
